/**
 * Created by coolguy on 2018/8/30.
 */
import {observable,action} from 'mobx';
import {arrDiff} from '../utils/util';
const commentApi = require("../actions/videoComment");
export default class VideoCommentStore{
    constructor(rootStore){
        this.rootStore = rootStore;
    }
    @observable commentList = [];
    @observable commentTop = [];
    @observable commentTotal = 0;
    @observable commentTopTotal = 0;
    @observable finished = false;
    @observable lastTime = Number.MAX_SAFE_INTEGER;
    @observable minCreateTime = new Date().getTime(); // 最小的创建时间，注意，加载更多是加载老的评论，而默认的刷新是加载最新的评论
    @action addOne(one){
        this.commentList = [one,...this.commentList];

    }
    getTop(galleryId) {
        return commentApi.top(galleryId).then(action(jsonData=>{
            if(jsonData && jsonData.data){
                this.commentTop = jsonData.data;
                this.commentTopTotal = (jsonData.data || []).length;
                return this.commentTop;
            }
        }))
    }
    getList(galleryid,id){
        return commentApi.list(galleryid,id,this.lastTime).then(action(jsonData=>{
            if(jsonData && jsonData.data){
                //现在有前端的前置评论了，必须得考虑去重问题
                // var temp = [
                //     ...this.commentList.slice(),
                //     ...jsonData.data,
                // ];
                // this.commentList = temp;
                // this.commentTotal = jsonData.total;
                //
                // if(this.commentTotal <= temp.length) {
                //     this.finished = true;
                // }
                //
                // if(this.commentList.length){
                //     this.lastTime = this.commentList[this.commentList.length - 1].createtime || 0;
                // }
                // //console.log(this.commentList.slice())
                // return this.commentList;
                if(jsonData && jsonData.data){
                    const sublength = jsonData.data.length;
                    const {total} = jsonData;
                    this.commentTotal = total;
                    // console.log(total);
                    //现在有前端的前置评论了，必须得考虑去重问题
                    this.commentList = [
                        ...arrDiff(this.commentList.slice(),jsonData.data,(a1,a2)=>{return a1.id === a2.id}),
                        ...jsonData.data
                    ];
                    const {length} = this.commentList;
                    // 认定如果返回的数量是0 或者返回的数量和 commentList一样 说明已经加载完所有评论
                    // （不考虑后来新增的评论，反正不定期的在刷新评论）
                    if(length === total || sublength < 50){
                        this.finished = true;
                    }
                    if(length){
                        // this.lastTime = this.commentList[0].createtime || 0;
                        this.minCreateTime = this.commentList[length-1].createtime;
                        this.lastTime = this.commentList[length-1].createtime;
                    }
                    //console.log(this.commentList.slice())
                    return this.commentList;
                }
            }
        }))
    }
    @action clear(){
        this.lastTime = Number.MAX_SAFE_INTEGER;
        this.minCreateTime = Date.now();
        this.commentList = [];
    }
}



// WEBPACK FOOTER //
// ./src/store/VideoCommentStore.js